const $inject = [
  "$scope",
  "$rootScope",
  "data",
  "roles",
];

class AdminController {
  constructor(
    $scope,
    $rootScope,
    data,
    roles
  ) {
    let self = this;
    this.$scope = $scope;
    $rootScope.data = data;
    $scope.roles = roles;

    $scope.show_toast = function ($message, $class) {
      self.globalMessage = {
        error: true,
        class: $class,
        errorMsg: $message,
        hideGlobalMessage: $scope.hide_toast,
      };
    };

    $scope.hide_toast = function () {
      self.globalMessage.error = false;
    };

    $rootScope.$on("display-toast", function (event, ...parameters) {
      $scope.show_toast.apply(self, parameters);
    });

    $rootScope.$on("remove-toast", function (event, ...parameters) {
      $scope.hide_toast.apply(self, parameters);
    });

    this.globalMessage = {
      error: false,
      class: null,
      errorMsg: null,
      hideGlobalMessage: $scope.hide_toast,
    };
  }
}

AdminController.$inject = $inject;
export default AdminController;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/admin/controllers/admin.controller.js
 **/